import { render, staticRenderFns } from "./SubmissionSession.vue?vue&type=template&id=123ebdb2&"
import script from "./SubmissionSession.vue?vue&type=script&lang=js&"
export * from "./SubmissionSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports